import Parse from "parse";
import { useEffect, useState } from "react";
import { Stop } from "../js/parsegenerated";

/**
 *
 * @returns All stops stored in the system.
 */
export function useStops() {
  const [stops, setStops] = useState<Stop[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Stop).find().then(setStops);
  }, [reload]);

  return [
    stops,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Stop[], () => void];
}
